import React from "react"

function IconCamera({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="camera"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-camera"
      {...props}
    >
      <path
        d="M13.86 2.564c.438 0 .857.164 1.176.456l.114.115 1.527 1.68h3.992a1.75 1.75 0 0 1 1.72 1.434l.022.155.007.16V17.67a1.75 1.75 0 0 1-1.59 1.741l-.159.008H3.222a1.75 1.75 0 0 1-1.742-1.59l-.007-.16V6.564c0-.912.698-1.661 1.59-1.741l.16-.007h4.136L8.868 3.14c.257-.286.598-.476.97-.547L10 2.572l.164-.008h3.697zm0 1.31h-3.696a.434.434 0 0 0-.256.081l-.067.061-1.897 2.108H3.222a.44.44 0 0 0-.431.35l-.01.09V17.67c0 .212.152.39.353.43l.088.01H20.67a.44.44 0 0 0 .431-.352l.009-.088V6.563a.44.44 0 0 0-.351-.43l-.089-.01h-4.571L14.18 4.015a.43.43 0 0 0-.23-.131l-.09-.01zM12.11 7.97a3.927 3.927 0 1 1 0 7.854 3.927 3.927 0 0 1 0-7.854zm0 1.31a2.618 2.618 0 1 0-.001 5.235 2.618 2.618 0 0 0 0-5.236z"
        fill={color}
        fillRule="evenodd"
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
    </svg>
  )
}

export default IconCamera
